//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    rang: { // 每页显示条数
      type: Number,
      default: 10,
    },
    rangs: {
      type: Array,
      default: () => {
        return [5, 10, 20, 50, 100]
      },
    },
    total: { // 总条数
      type: Number,
      default: 1,
    },
    showPageSize: {
      type: Boolean,
      default: true,
    },
  },
  data () {
    return {
      num: 1, // 总页数
      inputNumber: '',
      current: 1,
      preList: [],
      nextList: [],
      lazy: true,
      ishowRang: false,
      top: 25,
      rangItem: 0,
      threshold: 5, // 页码阈值,超过阈值出现省略号
    }
  },
  created () {
    const contain = this.rangs.some((item) => { if (item === this.rang) return true })
    if (!contain) { // 如果当前每页展示多少条，在数组中不存在，则将当前数据加入数组
      this.rangs.sort(this.sortRange)
    }
  },
  mounted () {
    this.num = Math.ceil(this.total / this.rang)
    this.rangItem = this.rang
    this.top = -this.rangs.length * 25
    this.computedPage()
  },
  watch: {
    total (val) {
      this.num = Math.ceil(this.total / this.rang)
      this.computedPage()
    },
    current () {
      this.$emit('current', {
        current: this.current,
        rang: this.rangItem,
      })
      this.computedPage()
    },
    rangItem (val) {
      this.$emit('current', {
        current: this.current,
        rang: this.rangItem,
      })
    },
    lazy (val) {
      if (val) {
        const inputNumber = parseInt(this.inputNumber)
        if (!isNaN(inputNumber)) {
          this.current = inputNumber
        }
        if (inputNumber > this.num) {
          this.current = this.num
        }
      }
    },
  },
  methods: {
    setCurrent (n) { // 设置当前选中页码
      if (this.current === n) { // 防止不触发watch
        console.log('防止不触发watch')
        this.$emit('current', {
          current: this.current,
          rang: this.rangItem,
        })
      } else {
        console.log('组件页面', this.current)
        this.current = n
      }
    },
    sortRange (a, b) {
      return a - b// 由低到高
    },
    selectRange (item) {
      this.num = Math.ceil(this.total / item)
      this.computedPage()
      this.current = 1

      this.rangItem = item
    },
    inputChange () { // 防抖节流
      if (!new RegExp('^[0-9]+$', 'g').test(this.inputNumber)) {
        this.inputNumber = ''
      }
      this.lazy = false
      clearTimeout(this.setTimeout)
      this.setTimeout = setTimeout(() => {
        this.lazy = true
      }, 100)
    },
    prePage () {
      if (this.current > 1) {
        this.current--
      }
    },
    nextPage () {
      if (this.current < this.num) {
        this.current++
      }
    },
    computedPage () { // 计算前后页码列表
      if (this.num > this.threshold) {
        if (this.current < this.threshold) {
          const list = []
          for (let i = 1; i <= this.threshold; i++) {
            list.push(i)
          }
          this.preList = list
          this.nextList = [this.num]
        } else {
          if (this.current < this.num - 3) {
            const list = []
            for (let i = this.current - 2; i <= this.current + 2; i++) {
              list.push(i)
            }
            this.preList = list
            this.nextList = [this.num]
          } else {
            this.preList = [1]
            const list = []
            for (let i = this.num - 4; i <= this.num; i++) {
              list.push(i)
            }
            this.nextList = list
          }
        }
      } else {
        const list = []
        for (let i = 1; i <= this.num; i++) {
          list.push(i)
        }
        this.preList = list
      }
    },
  },
}



// WEBPACK FOOTER //
// ./src/components/page-component/page-component.vue